import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem, captionClassName } from '@archipro-design/aria';

const DESKTOP_GROUP_LABEL_WIDTH = pxToRem(280);
const MOBILE_GROUP_LABEL_WIDTH = pxToRem(120);

export const Groups: StyleRule = ({ theme }) => ({
    rowGap: pxToRem(18),
    marginTop: pxToRem(19),
    '& > *': {
        borderBottom: `${pxToRem(1)} solid rgba(0, 0, 0, 0.06)`,
    },

    [theme.screen.min.tablet]: {
        rowGap: pxToRem(35),
        marginTop: pxToRem(44),
        '& > *': {
            border: 'none',
        },
    },
});

export const GroupLabel: StyleRule = ({ theme }) => ({
    display: 'flex',
    paddingTop: pxToRem(12),
    width: MOBILE_GROUP_LABEL_WIDTH,
    height: pxToRem(40),
    '> *': {
        letterSpacing: 0,

        [theme.screen.min.tablet]: {
            fontSize: pxToRem(16),
            letterSpacing: theme.siteVariables.letterSpacingMedium,
        },
    },

    [theme.screen.min.tablet]: {
        width: DESKTOP_GROUP_LABEL_WIDTH,
        paddingTop: 0,
    },
});

export const Group: StyleRule = ({ theme }) => ({
    flexDirection: 'column',
    width: `calc(100% - ${MOBILE_GROUP_LABEL_WIDTH})`,
    gap: pxToRem(14),
    padding: pxArrayToRem([4, 0, 19, 7]),

    [theme.screen.min.tablet]: {
        flexDirection: 'row',
        width: `calc(100% - ${DESKTOP_GROUP_LABEL_WIDTH})`,
        gap: pxToRem(28),
        padding: pxArrayToRem([0, 0, 13, 0]),
    },
});

export const DownloadWrapper: StyleRule = ({ theme }) => ({
    position: 'relative',
    width: '100%',

    [theme.screen.min.tablet]: {
        width: pxToRem(102),
        '&:nth-child(5n)': {
            width: pxToRem(96),
        },
    },
});

export const DownloadContainer: StyleRule = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',

    [theme.screen.min.tablet]: {
        flexDirection: 'column',
        alignItems: 'flex-start',

        '&:hover': {
            [`& .${captionClassName}`]: {
                color: theme.siteVariables.colors.primitive.black,
                textDecoration: 'underline',
            },
        },
    },
});

export const DownloadExtension: StyleRule = ({ theme }) => ({
    position: 'absolute',
    zIndex: 1,
    backgroundColor: '#1c1c1c',
    borderRadius: pxToRem(2.5),
    height: pxToRem(12),
    padding: pxArrayToRem([2, 4]),
    top: pxToRem(17),
    fontSize: pxToRem(8),
    lineHeight: theme.siteVariables.lineHeightDefault,
    color: theme.siteVariables.colors.white['000'],
    textTransform: 'uppercase',

    [theme.screen.min.tablet]: {
        height: pxToRem(20),
        padding: pxArrayToRem([0, 8.5, 0, 7.5]),
        top: pxToRem(71),
        fontSize: pxToRem(14),
        lineHeight: pxToRem(20),
        letterSpacing: theme.siteVariables.letterSpacingMedium,
    },
});

export const DownloadTileCorner: StyleRule = ({ theme }) => ({
    position: 'absolute',
    display: 'block',
    zIndex: 1,
    top: pxToRem(-1),
    left: pxToRem(25),
    width: pxToRem(8),
    height: pxToRem(8),

    [theme.screen.min.tablet]: {
        left: pxToRem(71),
        width: pxToRem(26),
        height: pxToRem(26),
    },
});

export const DownloadTileImage: StyleRule = ({ theme }) => ({
    marginLeft: pxToRem(3),
    width: pxToRem(30),
    height: pxToRem(34),

    [theme.screen.min.tablet]: {
        width: pxToRem(94.5),
        height: pxToRem(114),
    },
});

export const DownloadTileLabel: StyleRule = ({ theme: { screen } }) => ({
    padding: pxArrayToRem([0, 0, 0, 10]),
    lineHeight: 'normal',
    letterSpacing: 0,
    wordBreak: 'break-word',

    [screen.min.tablet]: {
        alignSelf: 'flex-start',
        padding: pxArrayToRem([5, 0, 0, 5]),
        lineHeight: '125%',
    },
});
